export default {
    clients: 'klijente',
    search_clients: 'Pretraži klijenta',
    choosen_client: 'Izabrani klijent',
    add_client: 'Podaci klijenta',
    add_new_client: 'Dodaj klijenta',
    invitation_link: 'Pozivni link',
    info: '*Pre kreiranja klijenta, proverite unete podatke. Ako unesete email, klijent će dobiti pozivnicu da dovrši registraciju putem emaila (preporučeno). Ako nema emaila, pozivnica stiže SMS-om jer je broj telefona obavezan. Klijent kasnije može menjati svoje podatke, dok vi unosite samo inicijalne. Ako email već postoji u našem sistemu, podaci će se automatski popuniti.*',
    number_of_clients:
        'Vaša kompanija trenutno ima <b>{number} klijenata</b> na <b>bookeraj</b> platformi – mestu gde su svi vaši važni kontakti uvek na dohvat ruke. 🚀',
    first_and_last_name: 'Ime i prezime',
    email: 'Email',
    phone_number: 'Broj telefona',
    active: 'Aktivan',
    records: 'Beleške',
    history: 'Istorija',
    client_reservations: 'Rezervacije korisnika: {client}',
    no_client_found: 'Klijent nije odabran!',
    client_not_selected: 'Klijent nije odabran, pa njegov unos neće biti sačuvan. Želite li nastaviti i potvrditi rezervaciju?',
    statistics: 'Statistika',
}
